module.exports = __webpack_public_path__ + "static/media/motel-pop.71890e49.png";